module.exports = __webpack_public_path__ + "media/img/automated-testing/benefits/benefits-img6-d049874c6c997273f1925fe9e9e12c40.svg";